import React from 'react'
import { XP_REQUEST_MODE, type ComponentProps, type PartData } from '@enonic/react-components'
import type { ResolvedLink } from '/types/CommonData'
import LocationMapPrototype from './prototype/LocationMap'
import type { LocationMapLocation } from './prototype/LocationMap/types'

type OfficeData = {
	id: string
	title: string
	address?: string
	email?: string
	latitude: number
	longitude: number
}

type LocationMapLabels = {
	zoomInLabel: string
	zoomOutLabel: string
	closeLabel: string
}

type LocationMapPartData = {
	subHeading?: string
	heading?: string
	intro?: string
	links?: ResolvedLink[]
	offices?: OfficeData[]
	labels?: LocationMapLabels
}

export const LocationMap = ({ meta, data }: ComponentProps<PartData>) => {
	const { subHeading, heading, intro, links = [], offices = [], labels } = (data || {}) as LocationMapPartData

	// An unconfigured part still has to render something in Content Studio, or the
	// editor cannot select it to fill it in.
	if (!subHeading && !heading && !intro && links.length === 0 && offices.length === 0) {
		return meta?.mode === XP_REQUEST_MODE.EDIT ? <section className="location-map location-map--empty" /> : <></>
	}

	const [primaryLink, secondaryLink] = links
	const primaryCta = primaryLink ? { text: primaryLink.label, url: primaryLink.url, isExternal: primaryLink.isExternal } : undefined
	const secondaryCta = secondaryLink ? { text: secondaryLink.label, url: secondaryLink.url, isExternal: secondaryLink.isExternal } : undefined

	const locations: LocationMapLocation[] = offices.map((office) => ({
		id: office.id,
		name: office.title,
		coordinates: [office.longitude, office.latitude],
		address: office.address,
		email: office.email,
	}))

	return (
		<LocationMapPrototype
			overline={subHeading}
			title={heading}
			intro={intro}
			primaryCta={primaryCta}
			secondaryCta={secondaryCta}
			locations={locations}
			labels={labels}
		/>
	)
}
